<script setup lang="ts">
/**
 * On/off switch row: label left, 18px switch right. On = normal (green) by the colour law;
 * off is neutral. Optional facts line under the label.
 * `bare` drops the label row and leaves the switch alone — the only form allowed inside a
 * table cell, where the column head already carries the word.
 */
defineProps<{ label: string; modelValue: boolean; facts?: string; disabled?: boolean; bare?: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [v: boolean] }>()
</script>

<template>
  <button
type="button" role="switch" :aria-checked="modelValue" :aria-label="label" :disabled="disabled"
    class="flex items-center gap-3 text-left disabled:opacity-50"
    :class="bare ? 'w-fit' : 'w-full justify-between'"
    @click="emit('update:modelValue', !modelValue)">
    <span v-if="!bare" class="flex min-w-0 flex-col">
      <span class="text-xs">{{ label }}</span>
      <span v-if="facts" class="num text-[length:var(--type-fine)] text-muted-foreground">{{ facts }}</span>
    </span>
    <span
class="relative h-[var(--measure-18px)] w-[var(--measure-30px)] shrink-0 rounded-full border transition-colors"
          :class="modelValue ? 'border-primary/60 bg-primary/25' : 'border-border bg-muted'">
      <span
class="absolute top-[var(--measure-2px)] size-3 rounded-full transition-transform"
            :class="modelValue ? 'translate-x-3.5 bg-primary shadow-glow-primary' : 'translate-x-0.5 bg-muted-foreground'" />
    </span>
  </button>
</template>
